// Auto-extracted from LangContext.jsx — single source of truth for ES translations.
// Edit this file to update wording. Keys must stay in sync across active locales (see ACTIVE_LANGS).
/* eslint-disable */
const dict = {
  app_tagline: 'El futuro de los playbooks de basketball',
  nav_dashboard: 'Panel', nav_playbook: 'Playbook', nav_editor: 'Editor', nav_roster: 'Roster',
  nav_ai: 'IA Coach', nav_live: 'Partido en Vivo', nav_simulator: 'Simulador', nav_academy: 'Academia',
  nav_invitations: 'Invitaciones', nav_admin: 'Admin', nav_pricing: 'Planes',
  nav_manual: 'Manual',
  nav_marketplace: 'Marketplace', nav_profile: 'Mi Perfil', nav_notifications: 'Notificaciones', nav_achievements: 'Logros',
  nav_tactile: 'Táctil', mob_market: 'Market', mob_ia: 'IA',
  login: 'Entrar', register: 'Registrarse', logout: 'Salir', email: 'Email', password: 'Contraseña',
  name: 'Nombre', role: 'Rol', coach: 'Entrenador', player: 'Jugador', or: 'o',
  welcome_back: 'Bienvenido de vuelta', create_account: 'Crear cuenta',
  invite_share_text: 'Hola {name}, te invitamos a unirte al equipo "{team}" en PlayMaster IA. Regístrate aquí: {url}',
  invite_share_text_generic: 'Te invitamos a unirte al equipo "{team}" en PlayMaster IA. Regístrate aquí: {url}',
  invite_share_text_no_team: 'Te invito a unirte a mi equipo en PlayMaster IA. Regístrate aquí: {url}',
  invite_share_title: 'Invitación · {name}',
  invite_share_native_text: 'Hola {name}, te invitamos a unirte al equipo "{team}" en PlayMaster IA.',
  register_invite_coach_team: 'El coach {coach} te está invitando a unirte al equipo {team}.',
  register_invite_coach_no_team: 'El coach {coach} te está invitando a crear tu cuenta.',
  register_show_password: 'Ver contraseña', register_hide_password: 'Ocultar contraseña',
  register_your_username: 'Tu usuario',
  register_save_credentials: 'Guarda este usuario y tu contraseña para volver a entrar. Te llevamos a tu playbook...',
  register_terms_intro: 'Al registrarte aceptas nuestros',
  register_terms_link: 'Términos',
  register_terms_and: 'y',
  register_privacy_link: 'Política de Privacidad',
  register_google_locale: 'es',
  plays: 'Jugadas', total_plays: 'Jugadas totales', active_players: 'Jugadores activos',
  success_rate: 'Tasa de éxito', ai_sessions: 'Sesiones IA',
  search: 'Buscar jugada...', all_categories: 'Todas las categorías',
  cat_man: 'vs Hombre', cat_zone: 'vs Zona', cat_ato: 'ATO', cat_blob: 'BLOB', cat_slob: 'SLOB', cat_endgame: 'Final de juego',
  create_play: 'Crear jugada', save: 'Guardar', cancel: 'Cancelar', edit: 'Editar', delete: 'Eliminar',
  upload_photo: 'Subir foto', add_player: 'Añadir jugador',
  height: 'Altura', weight: 'Peso', number: 'Número', position: 'Posición',
  dominant_hand: 'Mano dominante', strength: 'Fortaleza', weakness: 'Debilidad', ideal_role: 'Rol ideal',
  generate_link: 'Generar enlace de invitación', copy_link: 'Copiar enlace', copied: 'Copiado',
  chat_placeholder: 'Pregunta a la IA sobre tácticas, jugadas o jugadores...',
  send: 'Enviar', generate_play: 'Generar jugada', recommend_plays: 'Recomendar jugadas',
  predict_success: 'Predecir éxito',
  defense: 'Defensa', moment: 'Momento', recommend: 'Recomendar',
  step: 'Paso', steps: 'pasos', play: 'Reproducir', stop: 'Detener',
  pause: 'Pausar', prev: 'Anterior', next: 'Siguiente', loop_label: 'Loop', off_label: 'Off',
  worked: '✔ Funcionó', didnt_work: '✕ No funcionó',
  coach_premium: 'Coach Premium', player_premium: 'Player Premium', academy: 'Academia',
  plan_premium_monthly: 'Premium Mensual', plan_premium_annual: 'Premium Anual',
  plan_starter: 'Starter', plan_pro_coach: 'Pro Coach',
  plan_best_value: 'Mejor valor', plan_starter_addons_hint: 'Add-ons disponibles: IQ Score, Game IQ Simulator, Personal AI Coach',
  feat_everything_starter: 'Todo lo del Starter',
  feat_everything_unlimited: 'Todo ilimitado',
  feat_150_ai: '150 sesiones AI / mes',
  feat_30_players: 'Hasta 30 jugadores',
  feat_includes_iq_score: 'Incluye IQ Score',
  feat_includes_iq_full_suite: 'Incluye IQ Score + Game IQ Simulator + Personal AI Coach',
  addons_eyebrow: 'A LA CARTA',
  addons_title: 'Add-ons mensuales',
  addons_subtitle: 'Desbloqueá features individuales sin upgrade. Se cobran aparte de tu plan.',
  addon_iq_score_label: 'IQ Score',
  addon_iq_score_desc: 'Anotador de inteligencia de juego con rosters y estadísticas guardadas.',
  addon_iq_simulator_label: 'Game IQ Simulator',
  addon_iq_simulator_desc: '50+ escenarios reales evaluados por AI. Challenges y leaderboard.',
  addon_ai_coach_label: 'Personal AI Coach',
  addon_ai_coach_desc: 'Coach de IA personalizado que analiza tus jugadas y propone correcciones.',
  addon_buy: 'Activar add-on',
  addon_renew: 'Renovar',
  addon_included: 'Incluido en tu plan',
  month: 'mes', year: 'año', subscribe: 'Suscribirse',
  /* Manual */
  manual_h1: 'Manual de Instrucción',
  manual_subtitle: 'Guía completa de todas las funciones de PlayMaster IA. Se actualiza automáticamente con cada nueva versión.',
  manual_version: 'Versión',
  manual_search_placeholder: 'Buscar función…',
  /* Marketplace */
  marketplace_back: 'Volver al Marketplace',
  marketplace_elite_coach: 'Coach Élite',
  marketplace_about_play: 'Sobre esta jugada',
  marketplace_purchase_success: '¡Compra exitosa! Jugada añadida a tu playbook',
  marketplace_purchase_error: 'Error en la compra',
  marketplace_listing_not_found: 'Listing no encontrado.',
  marketplace_purchased: 'Comprada',
  marketplace_buy_cta: 'Comprar y añadir a mi playbook',
  marketplace_coaches_own: 'coaches ya tienen esta jugada en su playbook.',
  /* Roster */
  roster_invite_ready: 'Invitación lista — pulsa Compartir',
  manual_no_results: 'No se encontraron secciones para "{q}".',
  /* IQ Simulator landing (public) */
  iq_info_eyebrow: 'Nuevo · Función Premium Anual',
  iq_info_h1_a: 'Entrená el IQ', iq_info_h1_b: 'del basketball como un pro',
  iq_info_subtitle: 'El primer Simulador de IQ de basketball con IA — entrena decisiones reales de partido, no ejercicios aislados.',
  iq_info_para: 'Game IQ Simulator presenta escenarios reales — coberturas de pick-and-roll, lecturas de última posesión, defensa en transición. Elegís la decisión más inteligente, recibís feedback IA instantáneo, y tu IQ Score crece. Diseñado para juvenil, secundaria, AAU, academias y nivel profesional.',
  iq_info_cta_primary: 'Empezá a entrenar tu IQ', iq_info_cta_pricing: 'Ver planes',
  iq_info_video_coming: 'Video demo en vivo próximamente', iq_info_try_live: 'Probalo en vivo — registrate gratis',
  iq_info_video_fallback: 'Tu navegador no soporta video. Registrate para probar el simulador.',
  iq_info_pillars_eyebrow: 'Por qué importa el Game IQ',
  iq_info_pillars_h2: 'Dejá de drillear. Empezá a decidir.',
  iq_info_pillars_desc: 'Los jugadores élite están hechos de decisiones. PlayMaster IA trae la repetición de decisiones — esa que los scouting reports llaman "basketball IQ" — a un formato estructurado y repetible.',
  iq_info_p1_t: 'Escenarios reales de juego', iq_info_p1_d: 'Pick-and-roll vs Drop / Hedge / Switch · Ataque a zona · Última posesión · Transición · Defensa contra ISO de estrella — situaciones que todo jugador competitivo enfrenta antes de los U14.',
  iq_info_p2_t: 'Coaching IA instantáneo', iq_info_p2_d: 'Cada decisión es evaluada por Claude IA — recibís feedback específico en tu idioma, no elogios genéricos. Leés la explicación, corregís el error.',
  iq_info_p3_t: 'Trackeá tu IQ Score', iq_info_p3_d: 'Construí un score medible por categoría. Subí en el ranking de Walk-on a Floor General. Los coaches ven el progreso de los jugadores en su dashboard.',
  iq_info_how_eyebrow: 'Cómo funciona', iq_info_how_h2: '3 pasos hacia un jugador más inteligente',
  iq_info_s1_t: 'Elegí un escenario', iq_info_s1_d: 'Ofensivo, Defensivo — pronto Modo Completo con marcador, reloj y faltas.',
  iq_info_s2_t: 'Decidí en segundos', iq_info_s2_d: 'Leé la cancha, elegí la mejor opción entre 3. El tiempo de reacción cuenta.',
  iq_info_s3_t: 'Recibí feedback IA', iq_info_s3_d: 'Claude IA explica por qué tu lectura funcionó — o cuál era la decisión óptima.',
  iq_info_who_eyebrow: 'Diseñado para', iq_info_who_h2: 'Coaches, jugadores y academias que toman el IQ en serio',
  iq_info_who_list: 'Coaches de basketball juvenil|Programas de secundaria|Clubes AAU|Academias de basketball|Desarrollo de jugadores pro y semi-pro|Jugadores individuales desde 12 años',
  iq_info_inside_title: 'Incluido en el plan Premium Anual',
  iq_info_inside_desc: 'Game IQ Simulator está incluido en el plan Premium Anual — junto con el playbook completo, AI Coach, gestión multi-equipo, modo academia y soporte prioritario.',
  iq_info_final_h2: 'Hacé que tu próxima decisión de basketball sea inteligente',
  iq_info_final_para: 'Sumate a los coaches y jugadores que ya entrenan su basketball IQ con PlayMaster IA.',
  back_home: 'Volver al inicio', signup: 'Registrarse',
  /* Misc */
  processing: 'Procesando...',
  feat_iq_simulator: 'Game IQ Simulator',
  nav_iq_simulator: 'Game IQ Simulator',
  nav_iq_score: 'IQ Score',
  iq_module_label: 'Game IQ Simulator',
  iq_h1: 'Game IQ Simulator',
  iq_subtitle: 'Elevá tu IQ con escenarios reales de juego. Cada decisión la evalúa un AI coach.',
  iq_total_score: 'IQ Score',
  iq_accuracy: 'Precisión',
  iq_rank: 'Rango',
  iq_avg_reaction: 'Reacción avg',
  iq_cat_offensive: 'Ofensivo',
  iq_cat_defensive: 'Defensivo',
  iq_open_scenario: 'Abrir escenario',
  iq_what_do_you_do: '¿Qué hacés?',
  iq_reaction_tracking: 'Tiempo de reacción contando…',
  iq_evaluating: 'Evaluando decisión con IA…',
  iq_back_to_hub: 'Volver al simulador',
  iq_optimal: 'Decisión óptima',
  iq_suboptimal: 'No fue la mejor lectura',
  iq_optimal_was: 'La decisión óptima era',
  iq_tactical_explanation: 'Explicación táctica',
  iq_what_team_should: 'Qué debe hacer el equipo',
  iq_ai_coach: 'AI Coach',
  iq_try_another: 'Probar otro escenario',
  iq_no_scenarios: 'No hay escenarios en esta categoría todavía.',
  iq_premium_only: 'Función exclusiva del Premium Anual',
  iq_premium_pitch: 'Game IQ Simulator está incluido en el plan Premium Anual ($249.99/año) junto con todos los beneficios premium. El plan mensual no incluye esta función.',
  iq_premium_required: 'Función exclusiva del plan Premium Anual.',
  iq_upgrade_cta: 'Ver planes',
  // Phase 2 — Complete mode, leaderboard, TTS
  iq_cat_complete: 'Completo',
  iq_leaderboard: 'Ranking',
  iq_tts_on: 'Activar narración',
  iq_tts_off: 'Silenciar narración',
  iq_tts_label_on: 'Narración ON',
  iq_tts_label_off: 'Narración OFF',
  iq_gs_quarter: 'Cuarto',
  iq_gs_clock: 'Reloj',
  iq_gs_score: 'Marcador',
  iq_gs_fouls: 'Faltas',
  iq_gs_possession: 'Posesión',
  iq_gs_ours: 'Nuestra',
  iq_gs_theirs: 'Rival',
  iq_gs_bonus: 'Estás en bonus — cualquier falta defensiva del rival va a la línea.',
  iq_lb_all: 'Todos',
  iq_lb_empty: 'Aún no hay decisiones registradas. Empezá un escenario para entrar al ranking.',
  iq_lb_player: 'Jugador',
  iq_lb_score: 'IQ',
  iq_lb_attempts: 'Decisiones',
  iq_lb_acc: 'Prec.',
  iq_lb_you: 'TÚ',
  // Challenge Mode
  iqc_module_label: 'Challenge Mode',
  iqc_eyebrow: 'Game IQ Challenge',
  iqc_create_h: 'Crear desafío',
  iqc_create_title_label: 'Título del desafío',
  iqc_create_title_placeholder: 'Ej: Lecturas clutch — sub-17',
  iqc_create_submit: 'Crear desafío',
  iqc_create_success: '¡Desafío creado!',
  iqc_create_success_sub: 'Compartí este link con tus jugadores. Cualquiera con el link puede tomar el desafío.',
  iqc_cta_h: 'Desafiá a tus jugadores',
  iqc_cta_sub: 'Armá un set de 5 escenarios y compartilo por WhatsApp. El leaderboard del desafío se actualiza solo.',
  iqc_cta_btn: 'Crear desafío',
  iqc_my_h: 'Mis desafíos',
  iqc_attempts: 'intentos',
  iqc_created_by: 'Creado por',
  iqc_take_challenge: 'Tomar el desafío',
  iqc_login_to_take: 'Entrar y tomar el desafío',
  iqc_upgrade_to_take: 'Hazte Premium para tomar',
  iqc_how_h: '¿Cómo funciona?',
  iqc_how_1: '5 escenarios consecutivos — el reloj de reacción cuenta en cada uno.',
  iqc_how_2: 'Tu puntaje total queda registrado en el leaderboard del desafío.',
  iqc_how_3: 'Compartí el link por WhatsApp y mirá quién supera tu marca.',
  iqc_scenario: 'Escenario',
  iqc_total_so_far: 'Total acumulado',
  iqc_complete_eyebrow: 'Challenge completado',
  iqc_complete_h1: '¡Lo lograste!',
  iqc_summary_total: 'IQ Total',
  iqc_summary_correct: 'Aciertos',
  iqc_summary_accuracy: 'Precisión',
  iqc_take_again: 'Volver a intentar',
  iqc_share_my_result: 'Mi marca en este desafío',
  iqc_leaderboard_h: 'Top del desafío',
  iqc_max_5: 'Máximo 5 escenarios por desafío.',
  iqc_share_default_title: 'Tomá mi PlayMaster IA Challenge',
  iqc_share_default_text: 'Te reté en PlayMaster IA — {title}. ¿Aceptás el desafío?',
  iqc_not_found_h1: 'Desafío no encontrado',
  iqc_not_found_body: 'El link puede haber expirado o el código es incorrecto.',
  back_to_dashboard: 'Volver al Dashboard',
  iq_info_weekly_eyebrow: 'Lo más jugado esta semana',
  iq_info_alltime_eyebrow: 'Más jugados de siempre',
  iq_info_weekly_h: 'Top Challenges',
  iq_info_weekly_sub: 'Ranking en vivo de los desafíos creados por coaches más jugados. Tocá cualquier código para tomarlo — no necesitás registrarte para previsualizarlo.',
  iq_info_weekly_code: 'Código',
  iq_info_weekly_title: 'Desafío',
  iq_info_weekly_runs: 'Esta semana',
  iq_info_weekly_plays: 'Jugadas',
  /* IQ Score (live in-practice tracker) */
  iqs_eyebrow: 'Sistema oficial de evaluación',
  iqs_title: 'IQ Score',
  iqs_subtitle: 'Anotador de inteligencia de juego. Premia decisiones colectivas, no solo encestes. Pulsá una acción cada vez que tu equipo lea bien el juego — el primero en llegar al objetivo gana.',
  iqs_mode: 'Modo',
  iqs_target: 'Objetivo',
  iqs_mode_active: 'Modo',
  iqs_undo: 'Deshacer',
  iqs_reset: 'Reiniciar',
  iqs_team: 'Equipo',
  iqs_team_red: 'Rojo',
  iqs_team_black: 'Negro',
  iqs_impact_plays: 'Jugadas de impacto',
  iqs_winner: 'Ganador',
  iqs_target_reached: 'Alcanzó',
  iqs_new_game: 'Nuevo juego',
  iqs_total_actions: 'Acciones totales',
  iqs_leader: 'Va liderando',
  iqs_balance: 'Balance del juego',
  iqs_rules_title: 'Reglas y puntaje',
  iqs_rules_basic: 'Asistencia, rebote, bloqueo, robo y screen valen 1 punto. Pick & Roll completo: 1.5. Enceste sin jugada previa: 0.5.',
  iqs_rules_combos: 'Las jugadas combinadas (rebote ofensivo + canasta, bloqueo + pase + canasta, etc.) suman más que la suma de sus partes — premian la lectura encadenada.',
  iqs_rules_target: 'Configurá el objetivo (12, 20 o 21) y el modo (2v2 → 5v5). El primer equipo en llegar gana.',
  iqs_rules_purpose: 'Diseñado para que coaches y jugadores en banca aprendan viendo. Cada toque es una decisión de lectura.',
  /* IQ Score - actions */
  iqs_a_assist: 'Asistencia',
  iqs_a_rebound: 'Rebote',
  iqs_a_block: 'Bloqueo',
  iqs_a_steal: 'Robo',
  iqs_a_screen: 'Screen',
  iqs_a_pnr: 'Pick & Roll',
  iqs_a_bucket: 'Enceste',
  /* IQ Score - combos */
  iqs_c_oreb_score: 'Rebote of. + canasta',
  iqs_c_block_pass_bucket: 'Bloqueo + pase + canasta',
  iqs_c_steal_layup: 'Robo + bandeja',
  iqs_c_screen_pass_shot: 'Screen + pase + tiro',
  /* IQ Score - roster & save */
  iqs_pick_for: 'Elegir jugador para',
  iqs_add_player: 'Agregar jugador',
  iqs_no_roster: 'Tu roster está vacío. Andá a Roster para agregar jugadores.',
  iqs_no_players_left: 'Ya asignaste todos los jugadores disponibles.',
  iqs_add_selected: 'Agregar seleccionados',
  iqs_selected_count: '{n} seleccionado(s)',
  iqs_no_selection: 'Tocá los jugadores para seleccionarlos',
  /* Shot Analyzer */
  nav_shot_analyzer: 'Shot Analyzer',
  addon_shot_analyzer_label: 'Shot Analyzer',
  addon_shot_analyzer_desc: 'Análisis de mecánica de tiro con IA, silueta fantasma y reporte personalizado.',
  sa_eyebrow: 'Análisis de tiro con IA',
  sa_title: 'Shot Analyzer',
  sa_subtitle: 'Grabá un tiro, alineá tu cuerpo con la silueta y la IA evalúa tu mecánica frame a frame. 100% en tu dispositivo.',
  sa_manual_button: 'Manual',
  sa_manual_eyebrow: 'Antes de empezar',
  sa_manual_title: 'Manual de uso',
  sa_manual_intro: 'Para que el análisis sea preciso, seguí estas instrucciones cada vez que uses Shot Analyzer:',
  sa_manual_accept: 'Entendido y acepto',
  sa_manual_requirements_title: 'Requisitos mínimos',
  sa_manual_requirements_body: 'Móvil o tableta con cámara, luz uniforme, fondo despejado y permiso de cámara. El jugador y, si querés análisis de distancia, el aro deben estar visibles.',
  sa_manual_disclaimer: 'Análisis aproximado para feedback técnico. No es una herramienta biomecánica certificada.',
  sa_man_camera_title: 'Cámara estable',
  sa_man_camera_body: 'Colocá el celular en un trípode o apoyado. Altura cintura, perpendicular al jugador.',
  sa_man_distance_title: 'Distancia ~3m',
  sa_man_distance_body: 'El jugador debe entrar entero en pantalla (pies y manos). Probá hasta verlo completo.',
  sa_man_light_title: 'Buena iluminación',
  sa_man_light_body: 'Luz pareja sin contraluz. Evitá grabar contra ventanas o luces directas.',
  sa_man_align_title: 'Silueta fantasma',
  sa_man_align_body: 'Cuando empieces, vas a ver una silueta dorada. Imitá su postura. Cuando coincida 80% o más, arranca solo.',
  sa_man_good_title: 'Buen ejemplo',
  sa_man_good_body: 'Jugador centrado, perpendicular a la cámara, fondo despejado, luz uniforme, vestimenta contrastante.',
  sa_man_bad_title: 'Evitar',
  sa_man_bad_body: 'Cámara temblando, jugador cortado en pantalla, fondo del mismo color que la ropa, luz lateral fuerte.',
  sa_camera_denied: 'Acceso a la cámara denegado. Activalo en la configuración del navegador.',
  sa_not_enough_frames: 'Tiro muy corto. Probá de nuevo y mantenete dentro del cuadro durante todo el movimiento.',
  sa_save_fail: 'No se pudo guardar el intento',
  sa_status_loading_model: 'Cargando modelo de IA...',
  sa_status_idle: 'Listo para empezar',
  sa_status_align: 'Alineate con la silueta',
  sa_status_align_short: 'Alineá tu cuerpo',
  sa_align_headline: 'Alineate con la silueta.',
  sa_align_target: 'Objetivo',
  sa_status_capturing: 'Capturando tu tiro',
  sa_status_analyzing: 'Analizando mecánica',
  sa_status_done: 'Listo',
  sa_target_match: 'Objetivo',
  sa_start: 'Empezar análisis',
  sa_new_attempt: 'Nuevo intento',
  sa_upload_video: 'Subir video',
  sa_video_load_fail: 'No pudimos abrir el video',
  sa_video_pick_shooter: 'Tocá al tirador o dejalo en auto (bola)',
  sa_video_analyze: 'Analizar tiro',
  sa_status_video_scrub: 'Video · elegí al tirador',
  sa_shooter_locked: 'Tirador seleccionado',
  sa_shooter_ready: 'listo',
  sa_players_detected: 'jugadores',
  sa_model_error: 'Error cargando el modelo',
  sa_overall_score: 'Puntuación general',
  sa_metrics: 'Métricas',
  sa_errors: 'Errores detectados',
  sa_ai_report: 'Reporte del coach IA',
  sa_generating_report: 'Generando reporte...',
  sa_no_report: 'Sin reporte disponible',
  sa_history: 'Últimos intentos',
  sa_shot_side: 'Brazo de tiro',
  sa_side_right: 'Derecho',
  sa_side_left: 'Izquierdo',
  sa_disclaimer: 'Análisis aproximado para feedback técnico. No es una herramienta biomecánica certificada.',
  sa_gated_title: 'Shot Analyzer es un add-on',
  sa_gated_body: 'Desbloqueá el análisis de mecánica de tiro con IA por $6.99/mes (incluido en Premium Anual).',
  sa_gated_cta: 'Ver planes',
  /* Shot Analyzer - metric labels */
  sa_m_elbow: 'Ángulo del codo (release)',
  sa_m_knee: 'Flexión de rodilla (dip)',
  sa_m_release_h: 'Altura del release',
  sa_m_balance: 'Balance',
  sa_m_align: 'Alineación de hombros',
  sa_m_rhythm: 'Ritmo / fluidez',
  sa_m_leg_drive: 'Uso de piernas',
  sa_m_dip_ms: 'Tiempo dip → release',
  sa_m_follow_ms: 'Follow-through',
  /* Shot Analyzer - Phase 2 ball/arc metrics */
  sa_m_release_angle: 'Ángulo de liberación',
  sa_m_apex: 'Altura del arco',
  sa_m_arc_quality: 'Calidad del arco',
  sa_m_flight_time: 'Tiempo de vuelo',
  sa_m_rim_distance: 'Distancia al aro',
  sa_m_rim_made: 'Entró al aro',
  sa_rim_yes: 'Sí',
  sa_rim_no: 'No',
  sa_ball_section: 'Trayectoria del balón',
  sa_no_ball: 'Balón no detectado en esta toma',
  sa_tip_orange: 'Usá un balón naranja con buena iluminación para que el tracker funcione mejor.',
  /* Shot Analyzer - rim calibration */
  sa_rim_calibrate: 'Calibrar aro',
  sa_rim_tap_hint: 'Tocá el centro del aro en la pantalla',
  sa_rim_set: 'Aro marcado',
  sa_rim_reset: 'Resetear aro',
  sa_rim_auto: 'Auto',
  sa_rim_auto_hint: 'Detectar el aro automáticamente con visión por computadora',
  sa_rim_auto_ok: 'Aro detectado',
  sa_rim_auto_fail: 'No pudimos detectar el aro — tocá en pantalla',
  sa_camera_needed: 'Encendé la cámara primero',
  sa_show_trajectory: 'Ver trayectoria',
  sa_hide_trajectory: 'Ocultar trayectoria',
  /* Shot Analyzer - error labels */
  sa_err_open_elbow: 'Codo abierto',
  sa_err_low_release: 'Release bajo',
  sa_err_no_legs: 'No usás piernas',
  sa_err_lean_forward: 'Caída adelante',
  sa_err_lean_backward: 'Caída atrás',
  sa_err_broken_rhythm: 'Ritmo cortado',
  sa_err_pushed_shot: 'Tiro empujado',
  sa_err_lack_of_fluidity: 'Falta fluidez',
  sa_err_misalignment: 'Mala alineación',
  sa_err_flat_arc: 'Arco plano',
  sa_err_rainbow_arc: 'Arco arcoíris',
  sa_err_short_arc: 'Arco corto',
  sa_download_report: 'Descargar reporte PDF',
  sa_exporting: 'Generando PDF...',
  sa_export_fail: 'No se pudo generar el PDF',
  sa_pdf_title: 'Reporte de análisis de tiro',
  sa_pdf_player: 'Jugador',
  sa_pdf_attempts_logged: 'Intentos registrados',
  sa_pdf_personal_best: 'Mejor marca',
  sa_pdf_avg: 'Promedio',
  sa_pdf_errors_found: 'Errores detectados',
  sa_pdf_vs_last: 'vs último',
  sa_pdf_no_errors: 'Sin errores detectados en esta toma. Excelente ejecución.',
  sa_pdf_progress: 'Evolución (últimas 10 tomas)',
  sa_pdf_progress_caption: 'Puntuación general por intento. Eje Y: 0–100.',
  sa_pdf_recommendations: 'Recomendaciones para mejorar',
  sa_rec_elbow: 'Cerrá el codo: bajá la altura del codo a 90° en el release y mantenelo bajo la pelota. Drill: 50 form shots a 1 metro contra una pared.',
  sa_rec_release: 'Subí el set point: liberá la pelota por encima de la frente, no del pecho. Drill: 3×10 repeticiones frente al espejo concentrando el release alto.',
  sa_rec_legs: 'Usá las piernas: profundizá el dip hasta ~130° de rodilla para transferir energía. Drill: 4×8 chair shots — sentate, parate y disparás en un solo movimiento.',
  sa_rec_balance: 'Centrá el peso al saltar: cuerpo perpendicular al piso al release, sin caer adelante ni atrás. Drill: tiros estáticos sosteniendo el follow-through 3s.',
  sa_rec_rhythm: 'Trabajá la fluidez: un solo movimiento continuo dip→release, sin pausa. Drill: 3×10 tiros con conteo "1 (dip), 2 (release)".',
  sa_rec_follow: 'Sostené el follow-through al menos 1 segundo apuntando al aro. Drill: 2×15 form shots, cada uno con freeze de 2 segundos.',
  sa_rec_align: 'Cuadrá hombros y caderas al aro antes de subir. Drill: 10 tiros mirando primero los pies + caderas, después arrancar.',
  sa_rec_flat_arc: 'Subí el arco: apuntá a una trayectoria más alta (45°–52°). Drill: 3×10 tiros tratando de pasar la pelota por encima de un obstáculo a 2m, frente al aro.',
  sa_rec_rainbow_arc: 'Bajá un poco el arco: estás tirando demasiado alto, lo que reduce la precisión. Drill: 3×10 tiros buscando el "swish" plano del aro a ~48° de ángulo.',
  sa_rec_keep: 'Excelente ejecución. Reforzá el patrón con volumen.',
  sa_rec_volume: 'Hacé 3×25 tiros desde la misma posición esta semana para fijar la memoria muscular.',
  sa_rec_record: 'Grabate de nuevo en 48h y compará: mismo ángulo, mismo encuadre.',
  sa_send_to_coach: 'Enviar al coach por email',
  sa_sending: 'Enviando...',
  sa_send_ok: 'Reporte enviado a {email}',
  sa_send_fail: 'No se pudo enviar el email',
  sa_send_wait_save: 'Esperá a que se guarde el intento (unos segundos).',
  /* Shot Analyzer · Coach Inbox + Voice */
  sa_inbox_title: 'Análisis recibidos',
  sa_inbox_errors: 'errores',
  sa_voice_reply: 'Responder con voz',
  sa_voice_listen: 'Escuchar',
  sa_voice_played: 'Reproducir',
  sa_voice_from_coach: 'Nota del coach',
  sa_voice_play_fail: 'No se pudo reproducir el audio',
  sa_voice_modal_eyebrow: 'Nota de voz',
  sa_voice_modal_title: 'Grabar respuesta',
  sa_voice_for: 'Para',
  sa_voice_record: 'Grabar',
  sa_voice_pause: 'Pausar',
  sa_voice_resume: 'Continuar',
  sa_voice_stop: 'Detener',
  sa_voice_discard: 'Descartar',
  sa_voice_send: 'Enviar al jugador',
  sa_voice_sending: 'Enviando...',
  sa_voice_sent: 'Nota de voz enviada al jugador',
  sa_voice_send_fail: 'No se pudo enviar la nota',
  sa_voice_mic_denied: 'Acceso al micrófono denegado. Activalo en el navegador.',
  sa_voice_remaining: 'Restan {n}s · máx 60s',
  sa_voice_max: 'Máximo {n}s',
  /* Feedback */
  nav_feedback: 'Feedback',
  fb_eyebrow: 'Tu opinión importa',
  fb_title: 'Enviar feedback',
  fb_subtitle: 'Contanos qué podemos mejorar, qué te gustaría ver o reportar un bug. Cada mensaje lo lee nuestro equipo.',
  fb_category: 'Categoría',
  fb_cat_bug: 'Bug',
  fb_cat_bug_desc: 'Algo no funciona como debería',
  fb_cat_idea: 'Idea',
  fb_cat_idea_desc: 'Una mejora o feature nueva',
  fb_cat_praise: 'Felicitación',
  fb_cat_praise_desc: 'Algo que te encantó',
  fb_cat_other: 'Otro',
  fb_cat_other_desc: 'Cualquier otro comentario',
  fb_field_title: 'Título',
  fb_title_placeholder: 'Ej: "El botón de descarga no responde en Safari"',
  fb_field_body: 'Detalles',
  fb_body_placeholder: 'Contanos con detalle qué pasó, qué esperabas, en qué dispositivo, etc.',
  fb_field_rating: 'Tu experiencia general (opcional)',
  fb_send: 'Enviar feedback',
  fb_sending: 'Enviando...',
  fb_send_fail: 'No se pudo enviar el feedback',
  fb_validation: 'Completá el título (mín 3) y los detalles (mín 10 caracteres).',
  fb_success_title: '¡Gracias! Recibimos tu feedback.',
  fb_success_body: 'Lo vamos a revisar en las próximas 48h.',
  fb_send_another: 'Enviar otro',
  fb_disclaimer: 'Tu feedback se asocia a tu cuenta para poder seguirlo. No se comparte con terceros.',
  afb_nav: 'Feedback Inbox',
  afb_eyebrow: 'Triage interno',
  afb_title: 'Feedback Inbox',
  afb_subtitle: 'Revisá, etiquetá y respondé los mensajes que envían los usuarios.',
  afb_all: 'Todos',
  afb_status: 'Estado',
  afb_category: 'Categoría',
  afb_status_new: 'Nuevo',
  afb_status_triaged: 'En revisión',
  afb_status_done: 'Resuelto',
  afb_status_changed: 'Estado actualizado',
  afb_set_status: 'Cambiar estado',
  afb_stat_total: 'Total',
  afb_stat_new: 'Nuevos',
  afb_stat_triaged: 'En revisión',
  afb_stat_done: 'Resueltos',
  afb_empty: 'Sin feedback con estos filtros.',
  afb_replies: 'Respuestas previas',
  afb_reply_label: 'Responder al usuario por email',
  afb_reply_placeholder: 'Escribí tu respuesta. Se enviará por email al usuario y se notificará in-app.',
  afb_reply_send: 'Enviar respuesta',
  afb_sending: 'Enviando...',
  afb_reply_sent: 'Respuesta enviada a {email}',
  afb_reply_fail: 'No se pudo enviar la respuesta',
  afb_reply_validation: 'Escribí al menos 10 caracteres.',
  close: 'Cerrar',
  iqs_label_placeholder: 'Etiqueta (opcional): ej. "vs JV viernes 21/2"',
  iqs_save_game: 'Guardar partido',
  iqs_save_snapshot: 'Guardar avance',
  iqs_saving: 'Guardando...',
  iqs_save_ok: 'Partido guardado',
  iqs_save_fail: 'No se pudo guardar el partido',
  iqs_save_empty: 'Anotá al menos una acción antes de guardar',
  iqs_stats_title: 'Estadísticas del partido',
  iqs_breakdown: 'Desglose',
  iqs_history: 'Historial reciente',
  // Common
  hello: 'Hola', loading: 'Cargando...', view_all: 'Ver todo', back: 'Volver', close: 'Cerrar', confirm: 'Confirmar',
  language: 'Idioma', settings: 'Ajustes', not_found: 'No encontrada',
  top_plays: 'Top jugadas por tasa de éxito', distribution: 'Distribución', open_ai_coach: 'Abrir IA Coach',
  my_roster: 'Mi roster', my_publications: 'Mis Publicaciones', no_plays_yet: 'Aún no has creado jugadas propias',
  no_invitations_yet: 'Aún no has generado invitaciones', go_to: 'Ir a', go_to_editor: 'Ve al Editor',
  dashboard_subtitle: 'Panel de control de tu equipo', greeting_morning: 'Buenos días',
  privacy_policy: 'Política de privacidad', terms_of_service: 'Términos del servicio',
  error_generic: 'Error', invalid_credentials: 'Credenciales inválidas',
  have_account: '¿Ya tienes cuenta?', no_account: '¿No tienes cuenta?',
  invites_subtitle: 'Enlaces cortos con tu dominio y métricas de clics/uniones.',
  invite_label: 'Etiqueta', invite_label_placeholder: 'Equipo principal',
  invite_custom_slug: 'Slug personalizado (opcional)',
  voice: 'Voz', muted: 'Mudo',
  voice_on_hint: 'Narración activada (clic para silenciar)',
  voice_off_hint: 'Activar narración por voz',
  loop_on_hint: 'Repetir activado',
  loop_off_hint: 'Repetir desactivado',
  translating: 'Traduciendo...',
  // PlayDetail
  show_as: 'Mostrar como:', photo: 'Foto', initials: 'Iniciales',
  description_label: 'Descripción', works_against: 'Funciona contra',
  listen_narration: 'Escuchar narración', tactical_simulator: 'Simulador Táctico',
  ai_prediction: 'Predicción IA', export_share: 'Exportar y compartir',
  image_label: 'Imagen', share_whatsapp_btn: 'Compartir por WhatsApp', generating_dots: 'Generando…',
  delete_confirm: '¿Eliminar esta jugada?', deleted: 'Eliminada',
  pdf_generated: 'PDF generado', image_downloaded: 'Imagen descargada',
  frames_not_ready: 'Frames no listos, intenta de nuevo',
  share_error: 'Error al compartir', image_export_error: 'Error al exportar imagen',
  pdf_export_error: 'Error al exportar PDF', prediction_error: 'Error de predicción IA',
  feedback_success_yes: 'Marcada como exitosa', feedback_success_no: 'Marcada como fallida',
  feedback_error: 'Error al enviar feedback', translation_error: 'Error de traducción',
  cached_translation: 'Traducción cacheada', translated_by_ai: 'Traducido por IA',
  translated_to: 'Traducido a', translate_with_ai: 'Traducir con IA',
  whatsapp_open_attach: 'WhatsApp abierto: adjunta la imagen descargada',
  // Reviews
  reviews_title: 'Reseñas', your_review: 'Tu reseña', publish_review: 'Publicar reseña',
  update_review: 'Actualizar',
  review_placeholder: 'Opcional: cuéntale a otros coaches qué te pareció...',
  only_buyers_review: 'Solo coaches que han comprado pueden reseñar.',
  no_reviews_yet: 'Aún sin reseñas. Sé el primero.',
  choose_star: 'Elige al menos 1 estrella', review_sent: 'Reseña enviada',
  must_buy_review: 'Debes comprar esta jugada para reseñarla',
  review_singular: 'reseña', review_plural: 'reseñas',
  // PlayEditor
  editor_title: 'Play Creator Pro',
  editor_subtitle: 'Compatible con lápiz táctil, dedo y ratón. Selecciona "Lápiz libre" para dibujar.',
  blank_board: 'Pizarra en blanco', templates: 'Templates', preview_label: 'Vista previa',
  play_name: 'Nombre', play_description: 'Descripción',
  category: 'Categoría', difficulty: 'Dificultad',
  beginner: 'Principiante', intermediate: 'Intermedio', advanced: 'Avanzado',
  pencil_free: 'Lápiz libre',
  add_offense: '+Ofensiva', add_defense: '+Defensa',
  steps_title: 'Pasos', add_step: 'Añadir', step_description: 'Descripción del paso',
  speed: 'Velocidad', delay_exit: '⏱ Retraso al salir',
  assign_player_circle: 'Asignar jugador al círculo',
  quick_player_selection: 'Selección rápida de jugadores',
  animation_preview: 'Vista previa con animación',
  load_template_title: 'Cargar template',
  export_pdf_title: 'Exportar a PDF',
  export_png_title: 'Descargar como imagen',
  share_whatsapp_title: 'Compartir por WhatsApp',
  clear_text: 'Limpiar', unassigned: 'Sin asignar',
  double_click_assign: 'Doble-click sobre un círculo abre este selector. Foto + número + nombre se mostrarán en el token.',
  route_timing: 'Timing de rutas',
  route_timing_desc: 'Velocidad y retraso de cada jugador para coreografiar pick&roll, back-door, double screen…',
  my_roster_quick: 'Mi roster — toque rápido',
  players_count: 'jugadores',
  no_roster_yet_label: 'Aún no hay jugadores. Añade en',
  no_roster_yet_label_after: 'para selección rápida.',
  quick_add_hint: 'Toca un jugador y aparece al instante en la cancha. Doble-toque en un círculo para reasignar.',
  on_court_badge: 'EN CANCHA', tips_label: 'Tips',
  tip_offense_defense_a: 'toca la cancha para añadir un círculo genérico.',
  tip_pencil_a: 'dibuja la',
  tip_pencil_b: 'ruta del jugador',
  tip_pencil_c: 'partiendo de su círculo y el sistema añadirá el siguiente paso. Las curvas sueltas (no junto a un jugador) quedan como anotación.',
  tip_double_tap: 'Doble-toque sobre cualquier círculo para reasignarlo a un jugador del roster.',
  no_name: 'Sin nombre', my_new_play: 'Mi nueva jugada', step_default_desc: 'Paso',
  move_players: 'Mover jugadores', arrow_move: 'Flecha movimiento',
  pass_tool: 'Pase', dribble_tool: 'Dribbling', screen_tool: 'Pantalla', eraser_tool: 'Borrar',
  saved_ok: 'Guardado', save_error_msg: 'Error al guardar',
  // AICoach
  ai_hero_title: 'Hola, soy tu IA Coach',
  ai_hero_subtitle: 'Pídeme jugadas, optimizaciones, predicciones o estrategias.',
  ai_powered_by: 'Powered by PlayMaster IA',
  ai_quick_1_label: 'Crea una jugada contra zona 2-3',
  ai_quick_2_label: 'Recomiéndame jugadas ATO vs hombre',
  ai_quick_3_label: 'Optimiza Horns Flare',
  ai_quick_1_prompt: 'Diseña una jugada nueva para atacar una defensa en zona 2-3. Explícame los 3 pasos clave y por qué funciona.',
  ai_quick_2_prompt: 'Recomiéndame las 3 mejores jugadas ATO (after time-out) contra defensa al hombre. Justifica.',
  ai_quick_3_prompt: 'Tengo la jugada Horns Flare. ¿Cómo puedo optimizar el spacing y los ángulos de pantalla para hacerla más letal contra switches?',
  ai_connection_error: 'Error de conexión IA',
  // Academy
  academy_title: 'Academia',
  academy_subtitle: 'Conceptos tácticos, lectura de juego y fundamentos. Toca una lección para ver tutoriales de YouTube curados sobre el tema.',
  academy_will_open_youtube: 'Abriremos YouTube con tutoriales curados sobre este tema.',
  academy_watch_youtube: 'Ver tutoriales en YouTube',
  academy_coming_soon: 'Próximamente: lecciones nativas grabadas por entrenadores élite.',
  academy_lesson_1_title: 'Spacing: cómo abrir la cancha',
  academy_lesson_2_title: 'Cómo atacar la zona 2-3',
  academy_lesson_3_title: 'Defender Pick & Roll: drop coverage vs switch',
  academy_lesson_4_title: 'Lectura del juego: cuándo cambiar de ritmo',
  academy_lesson_5_title: 'Ejecución de Horns Action',
  academy_lesson_6_title: 'BLOB y SLOB en momentos clave',
  academy_cat_fundamentals: 'Fundamentos',
  academy_cat_vs_zone: 'Vs Zona',
  academy_cat_defense: 'Defensa',
  academy_cat_iq: 'IQ',
  academy_cat_systems: 'Sistemas',
  academy_cat_ato_blob: 'ATO/BLOB',
  // Pricing
  pricing_h1: 'Eleva tu juego', pricing_subtitle: 'Elige el plan que se adapta a tu coaching.',
  plan_most_popular: 'Más popular', payments_mocked: 'MOCKED · Los pagos se integrarán con Stripe en la próxima versión.',
  payments_secure: 'Pagos procesados de forma segura por Stripe.',
  pay_current_plan: 'Plan actual', pay_active: 'Activo', pay_expires_on: 'Vence el',
  pay_redirecting: 'Redirigiendo…', pay_cancelled: 'Pago cancelado. Intenta de nuevo cuando quieras.',
  pay_no_session: 'Sesión de pago no encontrada.',
  pay_verifying: 'Verificando pago…', pay_verifying_sub: 'Esto solo tomará unos segundos.',
  pay_thanks_tag: 'GRACIAS', pay_success_title: '¡Suscripción activada!',
  pay_success_plan: 'Plan', pay_go_dashboard: 'Ir al panel',
  pay_expired_title: 'Sesión expirada', pay_expired_sub: 'La sesión de pago expiró. Reintenta para continuar.',
  pay_timeout_title: 'Verificación pendiente', pay_timeout_sub: 'Estamos confirmando con Stripe. Revisa tu email; tu plan se activará cuando se confirme.',
  pay_error_title: 'Error de pago', pay_back_pricing: 'Volver a planes',
  stop_edit: 'Volver a editar',
  nav_teams: 'Equipos', teams_h1: 'Mis Equipos',
  teams_subtitle: 'Gestiona uno o varios equipos. Cada equipo tiene su propio roster y se aplica a todo el editor, playbook y comunicación.',
  teams_empty: 'Aún no tienes equipos. Crea el primero arriba.',
  team_create: 'Crear equipo', team_create_first: 'Crear equipo',
  team_name: 'Nombre del equipo', team_name_placeholder: 'Ej: Lobos U18',
  team_category: 'Categoría', team_cat_male: 'Masculino', team_cat_female: 'Femenino', team_cat_mixed: 'Mixto',
  team_created: 'Equipo creado', team_updated: 'Equipo actualizado', team_deleted: 'Equipo eliminado',
  team_delete_confirm: '¿Eliminar el equipo "{name}"? Los jugadores se moverán al siguiente equipo disponible.',
  team_active: 'Activo', team_already_active: 'Equipo activo', team_set_active: 'Activar',
  team_none: 'Sin equipo', team_manage: 'Administrar equipos',
  team_using: 'Usando equipo',
  roster_status_filter: 'Filtro',
  roster_status_active: 'Activos', roster_status_blocked: 'Bloqueados',
  roster_status_archived: 'Archivados', roster_status_all: 'Todos',
  roster_archive_confirm: '¿Archivar este jugador? Quedará oculto pero podrás reactivarlo en cualquier momento.',
  roster_player_archived: 'Jugador archivado',
  roster_player_reactivated: 'Jugador reactivado',
  roster_archive_title: 'Archivar', roster_reactivate: 'Reactivar',
  nav_assignments: 'Tareas', assignments_h1: 'Tareas Semanales',
  assignments_empty: 'Aún no hay tareas asignadas para este equipo.',
  assign_create: 'Crear tarea', assign_edit: 'Editar tarea',
  assign_title: 'Título', assign_title_placeholder: 'Ej: Repaso de la semana',
  assign_due: 'Vence', assign_notes: 'Notas (opcional)',
  assign_notes_placeholder: 'Indicaciones para los jugadores',
  assign_select_plays: 'Selecciona las jugadas', assign_no_plays: 'No hay jugadas disponibles',
  assign_created: 'Tarea creada', assign_updated: 'Tarea actualizada', assign_deleted: 'Tarea eliminada',
  assign_delete_confirm: '¿Eliminar esta tarea?', assign_overdue: 'VENCIDA', plays: 'jugadas',
  invite_team: 'Equipo', invite_team_none: 'Sin equipo asignado',
  nav_study: 'Estudio', study_h1: 'Seguimiento de Estudio',
  study_empty: 'Aún no hay actividad de estudio en este equipo.',
  study_player: 'Jugador', study_time: 'Tiempo', study_viewed: 'Jugadas vistas',
  study_completed: 'Completadas', study_progress: 'Progreso medio', study_last_seen: 'Última actividad',
  nav_groups: 'Grupos', groups_h1: 'Grupos del Equipo',
  groups_empty: 'No hay grupos aún', group_name_placeholder: 'Nombre del grupo',
  group_created: 'Grupo creado', group_deleted: 'Grupo eliminado',
  group_delete_confirm: '¿Eliminar este grupo y todos sus mensajes?',
  group_select: 'Selecciona un grupo para ver los mensajes',
  group_no_messages: 'Aún no hay mensajes',
  group_message_placeholder: 'Escribe un mensaje…',
  nav_notes: 'Notas', notes_h1: 'Notas privadas',
  notes_subtitle: 'Conversación 1:1 con tus jugadores.',
  notes_empty_inbox: 'Sin conversaciones aún',
  notes_select_conv: 'Selecciona una conversación',
  notes_no_messages: 'Aún no hay mensajes',
  notes_message_placeholder: 'Escribe un mensaje…',
  notes_new: 'Nuevo mensaje',
  notes_pick_player: 'Jugador',
  notes_no_registered_players: 'Este equipo aún no tiene jugadores registrados. Invitalos desde Roster para poder enviarles notas.',
  notes_all_teams: 'Todos mis equipos',
  nav_board: 'Pizarra',
  dash_this_week: 'Esta semana', dash_upcoming_tasks: 'tareas activas',
  dash_study_focus: 'Estudio del equipo', dash_inactive_players: 'sin actividad',
  dash_no_study_yet: 'Aún sin datos', dash_inbox: 'Bandeja de notas',
  dash_unread: 'sin leer',
  player_unread_notes: 'Notas sin leer', player_team_announcements: 'Anuncios del equipo',
  player_my_tasks: 'Mis tareas esta semana', player_your_coach: 'Tu coach',
  player_message_coach: 'Escribir al coach', player_coach_plays: 'jugadas del coach',
  player_coach_plays_title: 'Las jugadas de mi coach', player_global_sample: 'Playbook Global (muestra)',
  my_team: 'Mi Equipo', hello_greeting: '¡Hola',
  view: 'Ver', view_all: 'Ver todas', study: 'Estudiar', search: 'Buscar',
  play_part_of_task: 'Esta jugada es parte de tu tarea',
  play_ask_about: 'Preguntar al coach sobre esta jugada',
  roster_send_note: 'Enviar nota',
  msg_attach_play: 'Adjuntar jugada',
  team_choose: 'Elegir equipo', assign_team: 'Equipo',
  roster_invite_btn: 'Invitar', roster_invite_title: 'Invitar a registrarse',
  roster_invite_copied: 'Enlace copiado al portapapeles',
  roster_invite_created: 'Invitación creada',
  study_all_teams_subtitle: 'Vista global de todos tus equipos y jugadores.',
  study_players_count: 'jugadores',
  study_team_empty: 'Aún no hay actividad en este equipo',
  feat_playbook_full: 'Playbook completo (100 jugadas)',
  feat_advanced_editor: 'Editor avanzado',
  feat_unlimited_roster: 'Roster ilimitado',
  feat_50_ai: '50 sesiones IA/mes',
  feat_unlimited_invites: 'Invitaciones ilimitadas',
  feat_global_plays: 'Acceso a jugadas globales',
  feat_didactic_photos: 'Vista didáctica con tus fotos',
  feat_personal_ai_coach: 'IA Coach personal',
  feat_individual_stats: 'Estadísticas individuales',
  feat_academy_mode: 'Modo academia',
  feat_100_players: 'Hasta 100 jugadores',
  feat_multi_coach: 'Multi-coach',
  feat_unlimited_ai: 'IA sin límite',
  feat_personal_branding: 'Branding personalizado',
  feat_priority_support: 'Soporte prioritario',
  // LiveGame
  live_h1: 'Modo Partido en Vivo',
  live_subtitle: 'Selecciona la defensa rival y el momento; la IA te recomienda 3 jugadas.',
  live_voice_on: 'Voz activada — Modo Juego', live_voice_off: 'Activar narración por voz',
  live_voice_extra: 'Cada jugada se leerá en voz alta paso a paso.',
  live_defense_label: 'Defensa:', live_moment_label: 'Momento:',
  live_justification: 'Justificación IA', live_see_detail: 'Ver detalle',
  def_man: 'vs Hombre', def_zone_2_3: 'vs Zona 2-3', def_zone_3_2: 'vs Zona 3-2',
  def_zone_1_3_1: 'vs Zona 1-3-1', def_switch: 'vs Switch', def_press: 'vs Press',
  moment_half_court: 'Medio campo', moment_ato: 'After Time-out (ATO)',
  moment_blob: 'BLOB (Baseline)', moment_slob: 'SLOB (Lateral)', moment_endgame: 'Final de juego',
  // Profile
  marketplace_seller_blurb: 'te quedas el 85% de cada venta. Precio: $0.99 – $99.99.',
  // Profile
  profile_eyebrow: 'Perfil', profile_h1: 'Mi Perfil de Coach',
  profile_player_h1: 'Mi Perfil de Jugador',
  profile_player_subtitle: 'Tu coach ve esta misma información en el Roster.',
  profile_player_photo_help: 'Tu foto se mostrará en la pizarra cuando tu coach te asigne en una jugada.',
  elite_verified_badge: 'Coach Élite Verificado', identity_section: 'Identidad',
  no_photo: 'SIN FOTO', upload_photo_btn: 'Subir foto',
  photo_help: 'Tu foto y tus credenciales son lo primero que verán los compradores. Sé profesional.',
  field_display_name: 'Nombre público', field_team: 'Equipo', field_country: 'País',
  field_credentials: 'Credenciales (Ej: Head Coach · 10 años · Liga ACB)',
  field_twitter: 'Twitter / X (@usuario)', field_instagram: 'Instagram (@usuario)',
  field_website: 'Sitio web', field_bio: 'Bio (cuéntale a la comunidad qué tipo de coach eres)',
  save_profile_btn: 'Guardar perfil', elite_status: 'Estado Élite',
  verified_state: 'VERIFICADO',
  elite_active_text: 'Tu cuenta es élite. Tus jugadas son visibles en el Marketplace.',
  elite_since: 'Desde:', view_my_store: 'Ver mi tienda',
  not_elite_yet: 'Aún no eres Coach Élite. Solicita verificación para poder vender jugadas en el Marketplace.',
  requirements_label: 'Requisitos:',
  req_bio_photo: 'Bio + foto profesional', req_credentials: 'Credenciales verificables',
  req_5_plays: 'Mín. 5 jugadas propias creadas',
  request_verification: 'Solicitar verificación (admin only en v1)',
  my_achievements: 'Mis Logros', no_achievements: 'Aún no has desbloqueado logros.',
  publish_in_marketplace: 'Publicar en el Marketplace',
  unpublish_from_marketplace: 'Retirar del Marketplace',
  photo_uploaded: 'Foto subida', upload_error: 'Error subiendo',
  profile_saved: 'Perfil guardado', play_published: 'Jugada publicada en el marketplace',
  play_unpublished: 'Retirada del marketplace',
  price_prompt: 'Precio (USD, entre 0.99 y 99.99)',
  sale_blurb_prompt: 'Descripción corta de venta:', purchased_badge: '(Comprada)',
  // Landing
  landing_get_started: 'Comenzar', landing_install_app: 'Instalar app',
  landing_hero_subtitle: 'El primer playbook inteligente diseñado para entrenadores de basket. Diseña, simula y comparte jugadas con IA.',
  landing_feature_editor: 'Editor visual', landing_feature_editor_desc: 'Dibuja jugadas táctiles con tu dedo o lápiz. Animaciones automáticas.',
  landing_feature_ai: 'IA Coach', landing_feature_ai_desc: 'Genera jugadas, recomienda contra cualquier defensa, predice éxito.',
  landing_feature_share: 'Comparte fácil', landing_feature_share_desc: 'Exporta PDF, comparte por WhatsApp con animaciones reales.',
  landing_install_short: 'Instalar',
  landing_hero_h1_a: 'El futuro de los', landing_hero_h1_b: 'Playbooks de Basketball',
  landing_hero_h2: 'El playbook de basketball #1 con IA para coaches y jugadores',
  landing_hero_para: 'PlayMaster IA está redefiniendo el futuro de los playbooks de baloncesto con el ecosistema de coaching potenciado por IA más avanzado. Crea, enseña y ejecuta jugadas de baloncesto de élite usando un editor visual con fotos reales, una biblioteca creciente de jugadas profesionales, IA generativa y predictiva, gestión de roster, invitaciones y un sistema completo de desarrollo para equipos y academias.',
  landing_hero_para_2: 'Diseñado para baloncesto juvenil, secundaria, AAU, academias y coaching profesional, PlayMaster IA combina tecnología moderna con estrategia real de baloncesto para ayudar a coaches y jugadores a pensar más rápido, jugar más inteligente y ganar más.',
  landing_stat_plays: 'Jugadas', landing_stat_languages: 'Idiomas', landing_stat_coach_24: 'Coach 24/7',
  landing_live_preview: 'Live preview',
  landing_cap_eyebrow: 'Capacidades',
  landing_cap_h1_a: 'Un ecosistema completo', landing_cap_h1_b: 'para el básquet de élite',
  landing_f_playbook_t: 'Playbook Global', landing_f_playbook_d: 'Más de 117 jugadas profesionales — y creciendo — clasificadas por Hombre, Zona, ATO, BLOB, SLOB y Final de juego, todas con animaciones paso a paso y estructura didáctica.',
  landing_f_ai_t: 'IA Coach', landing_f_ai_d: 'Genera jugadas nuevas, optimiza las existentes y predice la probabilidad de éxito. Recomienda durante el partido en vivo.',
  landing_f_roster_t: 'Roster con Fotos', landing_f_roster_d: 'Sube fotos reales y crea fichas técnicas. Arrastra a tus jugadores a la cancha para jugadas 100% didácticas.',
  landing_f_langs_t: '3 Idiomas', landing_f_langs_d: 'Español, Inglés y Francés — con narración por IA, traducción automática y enriquecimiento didáctico.',
  landing_f_live_t: 'Modo Partido', landing_f_live_d: 'Selecciona la defensa rival y el momento; la IA recomienda 3 jugadas instantáneas con justificación táctica.',
  landing_f_editor_t: 'Editor Visual', landing_f_editor_d: 'Cancha NBA, herramientas flotantes, dibujo de movimientos, pantallas, cortes y pasos múltiples.',
  landing_cta_h1: '¿Listo para revolucionar tu pizarra?', landing_cta_demo: 'Coach demo:',
  landing_cta_btn: 'Empezar gratis', contact: 'Contacto',
  // Achievements
  achievements_eyebrow: 'Logros', achievements_h1: 'Mis Logros',
  achievements_subtitle_a: 'Desbloquea badges usando la app.', achievements_subtitle_b: 'desbloqueados.',
  achievements_progress: 'Progreso', achievements_latest: 'Últimos logros desbloqueados',
  achievements_no_data: 'Sin datos.', achievements_no_yet: '¡Empieza a usar la app!',
  cat_creation: 'Creación', cat_roster_t: 'Roster', cat_sales: 'Marketplace (Vendedor)',
  cat_buying: 'Marketplace (Comprador)', cat_quality: 'Calidad', cat_status: 'Estado', cat_ai: 'IA',
  tier_bronze: 'BRONCE', tier_silver: 'PLATA', tier_gold: 'ORO', tier_elite: 'ÉLITE',
  no_badges_yet: 'Sin logros aún.',
  // Notifications
  notifications_eyebrow: 'Notificaciones', notifications_h1: 'Centro de notificaciones',
  notif_enable_push: 'Activar Push', notif_test: 'Test', notif_disable_push: 'Desactivar push',
  notif_mark_all: 'Marcar todas', notif_empty: 'Sin notificaciones aún.',
  notif_marked_all: 'Todas marcadas como leídas',
  notif_push_on: 'Push activado. Te avisaremos incluso si cierras la app.',
  notif_push_off: 'Push desactivado', notif_push_error: 'No se pudo activar',
  notif_test_sent: 'Push test enviado', notif_test_error: 'Error enviando test',
  devices: 'dispositivo', devices_plural: 'dispositivos',
  // Marketplace
  market_h1: 'Playbooks de Élite',
  market_subtitle: 'Compra jugadas creadas por coaches verificados. Cada compra es una copia personal a tu playbook.',
  market_publish_my_play: 'Publicar mi jugada',
  market_publish_my_play_title: 'Publica tu jugada en el marketplace',
  market_banner_title: '¿Eres coach? Comparte y vende tu sistema',
  market_banner_body: 'Publica tus jugadas con animación, rutas y velocidades. Fija tu precio entre $0.99 y $99.99. Te quedas el 85% de cada venta.',
  market_banner_start: 'Empezar →',
  market_tab_listings: 'Jugadas en venta',
  market_tab_coaches: 'Coaches Élite',
  market_tab_leaderboard: 'Ranking · Coach del Mes',
  market_sort_popular: 'Popular',
  market_sort_recent: 'Recientes',
  market_sort_price_asc: 'Precio ↑',
  market_sort_price_desc: 'Precio ↓',
  market_cat_all: 'Todas',
  market_empty: 'No hay jugadas en venta en esta categoría aún.',
  market_sales: 'ventas',
  market_success: 'éxito',
  market_students: 'estudiantes',
  market_plays_count: 'jugadas',
  market_verified_elite: 'Élite Verificado',
  // Roster
  roster_h1: 'Roster',
  roster_player_updated: 'Jugador actualizado',
  roster_player_added: 'Jugador añadido',
  roster_save_error: 'Error guardando',
  roster_delete_confirm: '¿Eliminar jugador? (Quedará fuera del equipo permanentemente.)',
  roster_block_confirm: '¿Bloquear este jugador? Dejará de formar parte del equipo y no podrá ver tus jugadas.',
  roster_unblock_confirm: '¿Desbloquear este jugador? Volverá a tener acceso a tus jugadas.',
  roster_player_unblocked: 'Jugador desbloqueado',
  roster_player_blocked: 'Jugador bloqueado',
  roster_action_error: 'Error en la acción',
  roster_no_players: 'Aún no tienes jugadores. Pulsa',
  roster_camera_title: 'Tomar foto con la cámara',
  roster_upload_gallery_title: 'Subir desde galería',
  roster_camera_btn: 'Cámara',
  roster_upload_btn: 'Subir',
  roster_photo_uploaded: 'Foto subida',
  roster_photo_upload_error: 'Error subiendo foto',
  roster_blocked_badge: 'Bloqueado',
  roster_block_btn: 'Bloquear',
  roster_unblock_btn: 'Reactivar',
  roster_delete_title: 'Eliminar permanentemente',
  roster_block_title: 'Bloquear y sacar del equipo',
  roster_unblock_title: 'Desbloquear',
  roster_no_photo: 'SIN FOTO',
  roster_hand_right: 'Derecha',
  roster_hand_left: 'Izquierda',
  roster_hand_ambi: 'Ambidiestro',
  roster_hand_letter_right: 'D',
  roster_hand_letter_left: 'I',
  roster_hand_letter_ambi: 'A',
  roster_player_in_court: 'ya está en la cancha',
  roster_player_added_to_court: 'añadido',
  // Universal join panel
  ujp_eyebrow: 'Link universal del equipo',
  ujp_title: 'Un solo link para todos tus jugadores',
  ujp_subtitle: 'Compartilo una vez. Cualquier jugador que lo abra elige equipo + clave y queda en tu Roster.',
  ujp_active: 'Activo',
  ujp_paused: 'Pausado',
  ujp_copy: 'Copiar',
  ujp_share: 'Compartir',
  ujp_view: 'Ver',
  ujp_view_as_player_title: 'Abrir como lo vería un jugador',
  ujp_pin_section_title: 'PIN por equipo (opcional anti-spam)',
  ujp_active_tag: 'activo',
  ujp_pin_placeholder: '4-8 dígitos',
  ujp_no_pin: '— sin PIN —',
  ujp_change: 'Cambiar',
  ujp_add: 'Agregar',
  ujp_remove: 'Quitar',
  ujp_remove_pin_title: 'Eliminar PIN',
  ujp_footer: 'Sin PIN: cualquiera con el link entra. Con PIN: el jugador debe ingresarlo para sumarse a ese equipo.',
  ujp_link_copied: 'Link copiado',
  ujp_copy_failed: 'No se pudo copiar',
  ujp_share_native_title: 'Únete a mi equipo en PlayMaster IA',
  ujp_share_native_text: 'Registrate como jugador con este link único:',
  ujp_link_activated: 'Link activado',
  ujp_link_paused: 'Link pausado',
  ujp_link_update_error: 'Error al actualizar',
  ujp_pin_saved: 'PIN guardado',
  ujp_pin_removed: 'PIN eliminado',
  ujp_pin_save_error: 'Error al guardar PIN',
  // Share invite button
  sib_default_title: 'Invitación PlayMaster IA',
  sib_default_text: 'Te invito a unirte a mi equipo en PlayMaster IA. Regístrate aquí:',
  sib_native_error: 'No se pudo abrir el compartir nativo',
  sib_link_copied: 'Enlace copiado',
  sib_copy_failed: 'No se pudo copiar',
  sib_share: 'Compartir',
  sib_share_title: 'Compartir invitación',
  sib_copied: 'Copiado',
  sib_copy_link: 'Copiar enlace',
  // Invite QR button
  qrb_default_label: 'Invitación',
  qrb_download_failed: 'No se pudo descargar',
  qrb_show_qr_title: 'Mostrar QR para escanear',
  qrb_close: 'Cerrar',
  qrb_scan_to_join: 'Escanea para unirte',
  qrb_download_png: 'Descargar PNG',
  // Admin
  admin_h1: 'Panel Admin',
  admin_tab_overview: 'Dashboard',
  admin_tab_users: 'Usuarios',
  admin_tab_activity: 'Actividad',
  admin_coaches: 'Coaches',
  admin_players: 'Jugadores',
  admin_plays_global: 'Jugadas globales',
  admin_ai_sessions: 'Sesiones IA',
  admin_top_plays: 'Top jugadas',
  admin_by_category: 'Por categoría',
  admin_col_name: 'Nombre',
  admin_col_email: 'Email',
  admin_col_role: 'Rol',
  admin_col_created: 'Creado',
  admin_delete_user_confirm: '¿Eliminar usuario?',
  admin_recent_activity: 'Actividad reciente',
  admin_tab_maintenance: 'Mantenimiento',
  admin_backfill_title: 'Backfill enriquecimiento (todos los idiomas activos)',
  admin_backfill_body: 'Ejecuta UNA SOLA VEZ para enriquecer todas las jugadas en cada idioma activo (ES/EN/FR). Salta automáticamente las combinaciones ya enriquecidas — re-ejecutar es gratis. Las jugadas nuevas se enriquecen solas al crearlas.',
  admin_active_langs: 'Idiomas activos',
  // Offline
  offline_no_connection: 'Sin conexión',
  offline_pending: 'pendientes',
  offline_syncing: 'Sincronizando…',
  offline_synced: 'Sincronizado',
  offline_cached_session: 'Sesión local (sin conexión)',
  offline_play_unavailable: 'Esta jugada no está descargada. Conéctate para verla.',
  offline_saved_locally: 'Guardado localmente — se sincronizará al volver Internet',
  tablet_mode: 'Pantalla completa',
  tablet_mode_title: 'Pantalla completa para tableta — ideal para mostrar la jugada en juego o tiempo muerto',
  present_mode: 'Expandir',
  present_mode_title: 'Modo presentación: cancha fija a pantalla completa — sin movimiento accidental con dedo o lápiz',
  present_mode_exit: 'Cerrar',
  // Simulator
  sim_back_to_play: 'Volver a la jugada',
  sim_eyebrow: 'Simulador Táctico',
  sim_subtitle: 'La IA simulará cómo reaccionaría la defensa y te sugerirá ajustes concretos.',
  sim_rival_defense: 'Defensa rival',
  sim_exec_level: 'Nivel de ejecución',
  sim_run_now: 'Simular ahora',
  sim_running: 'Simulando...',
  sim_ai_prediction: 'Predicción IA',
  sim_confidence: 'Confianza:',
  sim_def_reaction: 'Cómo reaccionaría la defensa',
  sim_failure_points: 'Dónde fallaría',
  sim_adjustments: 'Ajustes recomendados',
  sim_key_player: 'Jugador #1:',
  // Templates Modal
  tpl_modal_eyebrow: 'Templates',
  tpl_modal_title: 'Empieza con un sistema probado',
  tpl_modal_subtitle: 'Jugadas pre-cargadas con velocidades y delays calibrados. Ajusta a tu gusto.',
  tpl_steps_count: 'pasos',
  diff_basic: 'Básico',
  diff_medium: 'Medio',
  diff_advanced: 'Avanzado',
  // Editor defensive shortcut
  editor_add_defenders: 'Añadir defensores',
  editor_add_defenders_title: 'Coloca 5 defensores en formación man-to-man',
  editor_defenders_added: '5 defensores añadidos',
  editor_defenders_already: 'Ya hay defensores en la cancha',
  editor_remove_defenders: 'Quitar defensa',
  editor_remove_defenders_title: 'Eliminar los 5 defensores de este paso',
  editor_defenders_removed: 'Defensa eliminada',
  // Enrichment (didactic descriptions)
  enrich_play: '✨ Enriquecer narración',
  regenerate_enrichment: '✨ Regenerar narración',
  enriching: 'Enriqueciendo...',
  enrichment_success: 'Jugada enriquecida — la voz y los textos ahora son más didácticos',
  enrichment_error: 'Error enriqueciendo la jugada',
  enrichment_hint: 'La IA genera explicaciones más largas y didácticas (Qué + Por qué + Consejo clave) para cada paso. La narración leerá el texto enriquecido.',
  // Bulk enrichment
  bulk_enrich_section_title: 'Enriquecimiento masivo',
  bulk_enrich_section_body: 'Enriquece TODAS tus jugadas de golpe en el idioma actual. La IA genera narraciones didácticas (Qué + Por qué + Consejo clave) que tus jugadores escucharán al reproducir cada jugada. Se ejecuta en segundo plano — puedes cerrar esta ventana, se preserva el progreso.',
  bulk_enrich_btn: '🚀 Enriquecer todas mis jugadas',
  bulk_enrich_running: 'Enriqueciendo',
  bulk_enrich_hint: 'Genera narraciones enriquecidas para todas tus jugadas en el idioma actual.',
  bulk_enrich_force_label: 'Forzar regeneración (también las ya enriquecidas)',
  bulk_enrich_in_progress: 'Enriqueciendo jugadas',
  bulk_enrich_done: '¡Enriquecimiento completado!',
  bulk_enrich_done_title: 'Listo',
  bulk_enrich_start_error: 'No se pudo iniciar el enriquecimiento',
  bulk_enrich_completed: 'Completadas',
  bulk_enrich_skipped: 'Omitidas (ya enriquecidas)',
  bulk_enrich_failed: 'Fallidas',
  bulk_enrich_current: 'Procesando ahora',
  bulk_enrich_errors: 'Errores',
  bulk_enrich_background_note: 'Esto puede tardar varios minutos según cuántas jugadas tengas. Puedes cerrar esta ventana — el proceso continúa en segundo plano.',

  // ── Public-facing surfaces (Plays Hub, Coach Profiles) — i18n batch 2026-02-25 ─────
  ph_counter_label: 'PLAYBOOK',
  ph_counter_word: 'JUGADAS',
  ph_tagline: 'Biblioteca pública de jugadas de baloncesto · diagramas, variantes y contexto táctico. Una nueva cada día.',
  ph_training_pill_prefix: 'Entrenando con',
  ph_training_pill_suffix: 'disparos de coaches reales',
  ph_filter_all: 'Todas',
  ph_sort_label: 'Ordenar:',
  ph_sort_recent: 'Recientes',
  ph_sort_popular: 'Populares',
  ph_sort_trending: 'En tendencia',
  ph_nav_blog: 'Blog',
  ph_nav_login: 'Login',
  ph_nav_signup: 'Crear cuenta',
  ph_nav_jugadas: 'Jugadas',
  ph_nav_coaches: 'Coaches',

  // Coach profile + directory
  cp_label_coach: 'COACH',
  cp_label_directory: 'DIRECTORIO',
  cp_loading: 'Cargando...',
  cp_404_title: 'Coach no encontrado',
  cp_404_body: 'Este perfil no existe o no es público.',
  cp_back_to_plays: 'Volver a jugadas',
  cp_his_plays: 'Sus jugadas',
  cp_no_plays_yet: 'Aún no ha publicado jugadas.',
  cp_stat_plays: 'Jugadas',
  cp_stat_likes: 'Likes',
  cp_stat_views: 'Vistas',
  cp_stat_verified: 'Verificado',
  cp_dir_coaches_label: 'Coaches',
  cp_dir_tagline: 'Comunidad pública de entrenadores compartiendo sus mejores jugadas. Descubre filosofías tácticas reales.',
  cp_dir_loading: 'Cargando coaches...',
  cp_dir_empty: '¿Eres coach? Actívalo desde tu perfil para aparecer aquí.',
  cp_seo_default_desc: '{name} comparte {count} jugadas de baloncesto en PlayMaster IA.',
  cp_seo_dir_desc: 'Directorio público de entrenadores de baloncesto en PlayMaster IA. Descubre coaches, sus jugadas y filosofía táctica.',

  // Public profile editor (inside /profile)
  ppe_title: 'Perfil público',
  ppe_subtitle: 'Activa tu página pública. Indexable por Google. Ideal para portafolio y recibir invitaciones.',
  ppe_public: 'PÚBLICO',
  ppe_private: 'PRIVADO',
  ppe_your_url: 'Tu URL:',
  ppe_copy: 'copiar',
  ppe_open: 'abrir',
  ppe_copied: 'Copiado',
  ppe_slug: 'Slug',
  ppe_country: 'País',
  ppe_country_placeholder: 'España',
  ppe_bio: 'Bio (máx 600)',
  ppe_bio_placeholder: 'Cuéntale a la comunidad sobre tu filosofía táctica.',
  ppe_twitter: 'Twitter (sin @)',
  ppe_instagram: 'Instagram (sin @)',
  ppe_website: 'Sitio web',
  ppe_website_placeholder: 'https://tu-academia.com',
  ppe_save: 'Guardar cambios',
  ppe_saving: 'Guardando...',
  ppe_save_success: 'Perfil actualizado',
  ppe_save_error: 'No se pudo guardar',
  ph_empty_state: 'Aún no hay jugadas publicadas en esta categoría. Vuelve mañana.',
  ph_loading_more: 'Cargando...',
  ph_load_more: 'Cargar más',
  ph_footer_privacy: 'Privacidad',
  ph_footer_terms: 'Términos',
  landing_f_iqsim_t: 'Game IQ Simulator',
  landing_f_iqsim_d: 'Pon a prueba la lectura táctica de tus jugadores con escenarios reales generados por IA. Calificación instantánea, explicación del coach y progreso medible.',
  landing_f_iqscore_t: 'IQ Score',
  landing_f_iqscore_d: 'Calificación oficial de IQ baloncestístico por jugador. Ranking del equipo, evolución histórica y comparativas entre rosters.',
  landing_f_shot_t: 'Shot Analyzer',
  landing_f_shot_d: 'Analiza la mecánica de tiro con visión por computadora. Detección de aro, trayectoria del balón, biomecánica y mapas de calor por jugador.',
  nav_group_dashboard: 'Dashboard',
  nav_group_roster: 'Roster',
  nav_group_ai: 'AI Coach',
  nav_group_marketplace: 'Marketplace',
  nav_group_profile: 'Mi Perfil',
  nav_board: 'Pizarra',
  // ── Editor Easy mode (visible UI strings) — i18n batch 2026-02-25 ───
  ee_action_pass: 'Pase',
  ee_action_dribble: 'Drible',
  ee_action_move: 'Movimiento',
  ee_action_cut: 'Corte',
  ee_action_screen: 'Pantalla',
  ee_action_block: 'Bloqueo',
  ee_action_handoff: 'Handoff',
  ee_action_shot: 'Tiro',
  ee_toast_defense_on: 'Modo defensivo',
  ee_toast_offense_on: 'Modo ofensivo',
  ee_toast_full_court: 'Cancha completa',
  ee_toast_half_court: 'Media cancha',
  ee_toast_clean: 'Cancha limpia',
  ee_toast_no_teammates: 'No hay compañeros',
  ee_toast_no_blockers: 'No hay compañeros para bloquear',
  ee_toast_add_defense_first: 'Añadí defensa primero',
  ee_toast_add_offense_first: 'Añadí ataque primero',
  ee_toast_move_outside_arc: 'Movete fuera del arco primero',
  ee_toast_save_failed: 'No se pudo guardar',
  ee_play_defensive: 'Jugada defensiva',
  ee_tooltip_fullscreen: 'Pantalla completa',
  ee_tooltip_exit_fullscreen: 'Salir de pantalla completa',
  ee_tooltip_category_default: 'Categoría por defecto (modificá el nombre para clasificar)',
  ee_tooltip_category_detected: 'Categoría detectada del nombre',
  ee_btn_remove_defense: 'Quitar defensa',
  ee_btn_remove_offense: 'Quitar ataque',
  ee_court_half: 'Media',
  ee_court_full: 'Completa',
  ee_team_offense: 'Ofensiva',
  ee_team_defense: 'Defensiva',
  ee_tooltip_advanced_mode: 'Modo avanzado con todas las herramientas',
  ee_tooltip_exit_editor: 'Salir del editor',
  ee_tooltip_edit_name: 'Editar nombre de la jugada',
  ee_draw_instruction: 'Arrastrá un jugador para crear su movimiento',
  ee_btn_add_defense: 'Añadir defensa',
  ee_btn_add_offense: 'Añadir ataque',
  ee_btn_clear: 'Limpiar',
  ee_btn_save: 'Guardar',
  ee_btn_saved: 'Guardado',
  ee_tooltip_drag_first: 'Arrastrá un jugador primero',
  ee_tooltip_save_play: 'Guardar la jugada',
  ee_toast_saved_offline: 'Guardado (offline)',
  ee_default_play_name: 'Jugada',
  ee_label_attack: 'ATAQUE',
  ee_label_defense: 'DEFENSA',
  ph_cta_title: 'Desbloqueá la biblioteca completa de jugadas',
  ph_cta_subtitle: 'Estás viendo solo un avance. Registrate gratis para acceder al diagrama paso a paso, las variantes y la lógica táctica de cada jugada.',
  ph_cta_button: 'Crear cuenta gratis',
};

export default dict;
